import { render, staticRenderFns } from "./SummaryRelationChart.vue?vue&type=template&id=1c665452&scoped=true"
import script from "./SummaryRelationChart.vue?vue&type=script&lang=js"
export * from "./SummaryRelationChart.vue?vue&type=script&lang=js"
import style0 from "./SummaryRelationChart.vue?vue&type=style&index=0&id=1c665452&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c665452",
  null
  
)

export default component.exports